import { CSSProperties } from 'react';

import { StepImage as StyledStepImage } from './style';
import last from 'lodash/last';

export const StepImage = ({
  src,
  height,
  style,
  width,
}: {
  src: string;
  height?: number;
  style?: CSSProperties;
  width?: number;
}) => <StyledStepImage alt={last(src.split('/'))} height={height} src={src} style={style} width={width} />;
